import { Stack, Typography } from "@mui/material";
import { InfoGroup } from "Components/Contact/InfoGroup";
import { Resources, useResource } from "Translations/Resources";
import type { AccessRoleCode } from "Models/AccessRoleCodes";

const COMPONENT_RESOURCES = Resources.Pages.Content.Contact.BankInfo;

type Props = {
  userRole: AccessRoleCode;
};

export const BankInfo = ({ userRole }: Props) => {
  const { t } = useResource();

  const czkAccountInfo = t(COMPONENT_RESOURCES.CZKAccount[userRole]);
  const eurAccountInfo = t(COMPONENT_RESOURCES.EURAccount[userRole]);

  return (
    <InfoGroup title={t(COMPONENT_RESOURCES.Title)}>
      <Stack>
        {czkAccountInfo && <Typography>{czkAccountInfo}</Typography>}
        {eurAccountInfo && <Typography>{eurAccountInfo}</Typography>}
      </Stack>
    </InfoGroup>
  );
};
